import { Service } from "../Interfaces/Service";
import Axios from "axios";


export const globalServices = {
    get,
    post,
    postAuth,
    remove,
    put
};

function get<T>(path: string) {
    return new Promise<Service<T>>((resolve, reject) => {
        Axios.get(path)
            .then((response) => {
                if (response.status >= 400) return Promise.reject(response);
                return response.data;
            })
            .then((response) => {
                console.log(path, response);
                resolve({ status: "loaded", payload: response });
            })
            .catch((error) => {
                //console.log("error", error);
                reject({ status: "error", error });
            });
    });
}

function post<T>(path: string, params: any) {
    return new Promise<Service<T>>((resolve, reject) => {
        Axios.post(path, params)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    //console.log("response", response.data);
                    resolve({ status: "loaded", payload: response.data });
                } else {
                    return Promise.reject(response);
                }
            })
            .catch((error) => {
                //console.log("error", error);
                reject({ status: "error", error });
            });
    });
}

function put<T>(path: string, params: any) {
    return new Promise<Service<T>>((resolve, reject) => {
        Axios.put(path, params)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    //console.log("response", response.data);
                    resolve({ status: "loaded", payload: response.data });
                } else {
                    return Promise.reject(response);
                }
            })
            .catch((error) => {
                //console.log("error", error);
                reject({ status: "error", error });
            });
    });
}

function postAuth<T>(path: string, params: any) {
    return new Promise<Service<T>>((resolve, reject) => {
        Axios.post(path, params)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    //console.log("response", response.data);
                    localStorage.setItem("deloof.service.user", JSON.stringify(response.data));
                    resolve({ status: "loaded", payload: response.data });
                } else {
                    return Promise.reject(response);
                }
            })
            .catch((error) => {
                //console.log("error", error);
                reject({ status: "error", error });
            });
    });
}
function remove<T>(path: string, params: any) {
    return new Promise<Service<T>>((resolve, reject) => {
        Axios.delete(path, params)
            .then((response) => {
                if (response.status >= 400) return Promise.reject(response);
                return response.data;
            })
            .then((response) => {
                resolve({ status: "loaded", payload: response });
            })
            .catch((error) => {
                reject({ status: "error", error });
            });
    });
}